import { ReactElement, useState } from 'react'
import classNames from 'classnames/bind'
import { Icon, Button } from '@frontend-mono/shared/design-system'
import { useTranslation } from 'next-i18next'
import styles from './ModalNewButton.module.scss'

const cx = classNames.bind(styles)

type NewPlaylistProps = {
  TitleInput: ReactElement
  onCreate: () => Promise<boolean>
  onCancel: () => void
}

export const NewPlaylistButton = ({ TitleInput, onCreate, onCancel }: NewPlaylistProps) => {
  const { t } = useTranslation()
  const [shouldRenderForm, setShouldRenderForm] = useState(false)
  const handleCreate = async () => {
    const success = await onCreate()
    if (success) {
      setShouldRenderForm(false)
    }
  }
  const handleCancel = () => {
    onCancel()
    setShouldRenderForm(false)
  }
  return (
    <div>
      {!shouldRenderForm && (
        <button type="button" className={cx('trigger')} onClick={() => setShouldRenderForm(true)}>
          <div className={cx('icon')}>
            <Icon name="add" />
          </div>
          <span className={cx('text')}>{t('Playlist__create_playlist')}</span>
        </button>
      )}
      {shouldRenderForm && (
        <div className={cx('form')}>
          {TitleInput}
          <div className={cx('buttons')}>
            <div className={cx('button')}>
              <Button variant="secondary" fullWidth onClick={handleCancel}>
                {t('Playlist__cancel')}
              </Button>
            </div>
            <div className={cx('button')}>
              <Button variant="primary" fullWidth onClick={handleCreate}>
                {t('Playlist__create')}
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
